import queryString from 'query-string'

export default (state) => {

  const selections = state.selections

  const style = []
  const cuisine = []
  const award = []
  let partySize = null
  const clubOffersTimes = []
  let clubOffersOnly = null


  selections.map(selection => {

    let { field, value } = selection

    if ( selection.filters ) {
      field = selection.filters[0].field
    }

    switch(field) {
      case 'cuisines.description':
        cuisine.push(value)
        break;
      case 'awards.name':
        award.push(selection.filters[0].value + '-' + selection.filters[1].value )
        break;
      case 'ambiences.description':
        style.push(value)
        break;
      case 'private_dining_rooms.min_capacity':
        partySize = selection.filters[0].value + '-' + selection.filters[1].value
        break;
      case 'membership_validities.meal.name':
        clubOffersTimes.push(selection.filters[0].value.charAt(0).toUpperCase() + selection.filters[1].value )
        break;
      case 'limited_edition_bool':
        clubOffersOnly = true
        break;
    }
  })


  const params = {}

  if (state.page) {
    params['current_page'] = state.page
  }
  if (state.per_page) {
    params['per_page'] = state.per_page
  }
  if (state.sortBy) {
    params['sort'] = state.sortBy
  }
  if (state.searchTerm) {
    params['terms'] = state.searchTerm
  }
  if (state.searchType) {
    params['type'] = state.searchType
  }
  if ( style.length ) {
    params['style'] = style
  }
  if ( partySize ) {
    params['partySize'] = partySize
  }
  if ( cuisine.length ) {
    params['cuisine'] = cuisine
  }
  if ( award.length ) {
    params['award'] = award
  }
  if ( clubOffersOnly ) {
    params['clubOffersOnly'] = 1
  }
  if ( clubOffersTimes.length ) {
    params['clubOffersTimes'] = clubOffersTimes
  }

  const order = [
    'current_page',
    'per_page',
    'sort',
    'terms',
    'type',
    'style',
    'partySize',
    'cuisine',
    'award',
    'clubOffersOnly',
    'clubOffersTimes',
  ]
  const queryOptions = {
    arrayFormat: 'comma',
    sort: (a, b) => order.indexOf(a) - order.indexOf(b),
  }
  const paramsString = queryString.stringify(params, queryOptions)

  window.history.replaceState({}, '', `${location.pathname}?${paramsString}`);

}
